<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (pageLoading1) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
@if (navbar.userAccess?.Invoice=='Full' || navbar.userAccess?.Invoice=='Readonly') {
<div class="row">
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-header">
				<h5 class="card-title mb-0">
					{{pagetitle}}
					@if (navbar.userAccess?.Invoice=='Full') {
					<a class="btn btn-sm btn-success float-end" [routerLink]="['/app/case-invoice-create',uId]">
						Create Bill
					</a>
					}
					@if (caseDetails?.mark_for_closure) {
					<span class="float-end text-dark me-3 mt-1">
						<fa-icon [icon]="['fas',caseDetails?.mark_for_closure?'check-square':'square']"
							[ngClass]="caseDetails?.mark_for_closure?'text-success':'text-custom'"
							class="mark-for-closure">
						</fa-icon>
						Marked for closure
					</span>
					}
					<span class="float-end text-dark me-3 mt-1">
						Case-Id:
						<strong>
							{{caseDetails?.case_id}}
						</strong>
					</span>
					<span class="float-end text-dark me-3 mt-1">
						<strong>
							<fa-icon [icon]="['fas',caseDetails?.status==2?'lock':'lock-open']"
								[matTooltip]="caseDetails?.case_status">
							</fa-icon>
						</strong>
					</span>
				</h5>
			</div>
			<div class="card-body">
				<div class="row mb-2">
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>To&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.company?.name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Name&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.f_name}} {{caseDetails?.l_name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Rank&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.rank_name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Vessel&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.vessel}}
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<label class="form-label">Billing Status:</label>
						<mat-radio-group [(ngModel)]="billing_status" (change)="billingStatusChanged()"
							[disabled]="navbar.userAccess?.Invoice!='Full'">
							<mat-radio-button [value]="1" [color]="'primary'">
								Partial Billing
							</mat-radio-button>
							<mat-radio-button [value]="2" [color]="'primary'">
								Full Billing
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-body">
				<ul class="nav nav-tabs nav-tabs-bordered">
					<li class="nav-item" role="button" (click)="setActiveTab(0)">
						<a class="nav-link" [ngClass]="getTabClass(0)" data-bs-toggle="tab" role="tab"
							aria-controls="ex1-tabs-1" aria-selected="true">
							INR
						</a>
					</li>
					<li class="nav-item" role="button" (click)="setActiveTab(1)">
						<a class="nav-link" [ngClass]="getTabClass(1)" data-bs-toggle="tab" role="tab"
							aria-controls="ex1-tabs-1" aria-selected="true">
							USD
						</a>
					</li>
					@if (navbar.userAccess?.Billing=='Full' || navbar.userAccess?.Billing=='Readonly') {
					<li class="nav-item" role="button" (click)="setActiveTab(2)">
						<a class="nav-link" [ngClass]="getTabClass(2)" data-bs-toggle="tab" role="tab"
							aria-controls="ex1-tabs-1" aria-selected="true">
							Billing
						</a>
					</li>
					}
				</ul>
				<div class="tab-content">
					<div id="tab0" [ngClass]="getTabPaneClass(0)">
						@if (pageLoading2) {
						<div class="loader text-center">
							<img src="../../../assets/img/loading.gif" style="width: 100px;" />
							<p style="color: black;font-weight: bolder;">Loading...</p>
						</div>
						}
						<table class="table table-bordered">
							<thead>
								<tr>
									<th style="width: 10% !important;">
										@if (navbar.userAccess?.Invoice=='Full') {
										<mat-checkbox color="primary" [(ngModel)]="checkAll"
											(change)="checkUncheckAll()"></mat-checkbox>
										}
									</th>
									<th style="width: 20% !important;">Invoice No.</th>
									<th style="width: 20% !important;">Tele Consult</th>
									<th style="width: 10% !important;">Invoice Date</th>
									<th style="width: 10% !important;">Due Date</th>
									<!-- <th style="width: 5% !important;">Billed</th>
									<th style="width: 5% !important;">Paid</th> -->
									<th style="width: 10% !important;" class="text-end">Amount</th>
									<th style="width: 20% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								@for (inv of billingList; track $index) {
								<tr [ngClass]="inv.is_usd_done?'blue':''">
									<td>
										@if (navbar.userAccess?.Invoice=='Full'){
										<mat-checkbox color="primary" [(ngModel)]="inv.checked" (change)="billChecked()"
											[disabled]="inv.is_usd_done"
											[matTooltip]="inv.is_usd_done?'Already converted':'Select to convert'"></mat-checkbox>
										}
									</td>
									<td>{{inv.invoice_number}}</td>
									<td>{{inv.tele_consult_count}}</td>
									<td>{{inv.invoice_date}}</td>
									<td>{{inv.due_date}}</td>
									<!-- <td>
										@if(inv.bill_flag){
										<fa-icon [icon]="['fas','check']" class="text-success"></fa-icon>
										}@else{
										<fa-icon [icon]="['fas','minus']" class="text-danger"></fa-icon>
										}
									</td>
									<td>
										@if(inv.paid_flag){
										<fa-icon [icon]="['fas','check']" class="text-success"></fa-icon>
										}@else{
										<fa-icon [icon]="['fas','minus']" class="text-danger"></fa-icon>
										}
									</td> -->
									<td class="text-end">{{inv.total_amount}}</td>
									<td>
										<a class="btn btn-sm btn-primary me-1" matTooltip="Print"
											[routerLink]="['/app/invoice-pdf','inr',uId,inv.enc_id]" target="_blank">
											<fa-icon [icon]="['fas','print']"></fa-icon>
										</a>
										@if (navbar.userAccess?.Invoice=='Full'){
										@if (!inv.is_usd_done) {
										<a class="btn btn-sm btn-info me-1" matTooltip="View / Edit"
											[routerLink]="['/app/case-invoice-edit',uId,inv.enc_id]">
											<fa-icon [icon]="['fas','edit']"></fa-icon>
										</a>
										<button class="btn btn-sm btn-danger me-1" matTooltip="Delete"
											(click)="deleteConfirm(inv.enc_id)">
											@if (showDeleteLoader == inv.enc_id) {
											<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
											}@else {
											<fa-icon [icon]="['fas','times']"></fa-icon>
											}
										</button>
										}
										}
										<!-- @if (inv.invoice_path) { -->
										<button class="btn btn-sm btn-success me-1"
											matTooltip="Copy invoice link to clipboard"
											(click)="copyInvLinkToClipboard(inv,'INR')">
											@if (copyLoader === inv.enc_id) {
											<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
											}@else {
											<fa-icon [icon]="['fas','copy']"></fa-icon>
											}
										</button>
										<!-- } -->
									</td>
								</tr>
								}
							</tbody>
						</table>
						@if (navbar.userAccess?.Invoice=='Full'){
						<button type="button" class="btn btn-sm btn-success mt-2"
							(click)="openConvertModal(false,null)">
							Convert to USD
						</button>
						}
					</div>
					<div id="tab1" [ngClass]="getTabPaneClass(1)">
						@if (pageLoading3) {
						<div class="loader text-center">
							<img src="../../../assets/img/loading.gif" style="width: 100px;" />
							<p style="color: black;font-weight: bolder;">Loading...</p>
						</div>
						}
						<table class="table table-bordered">
							<thead>
								<tr>
									<th style="width: 20% !important;">Invoice No.</th>
									<th style="width: 15% !important;">Invoice Date</th>
									<th style="width: 15% !important;">Due Date</th>
									<th style="width: 10% !important;">Billed</th>
									<th style="width: 10% !important;">Paid</th>
									<th style="width: 30% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								@for (inv of billingListUSD; track $index) {
								<tr [ngClass]="!inv.isActive?'red':''">
									<td>
										{{inv.usd_invoice_number}}
									</td>
									<td>
										{{inv.usd_invoice_date}}
									</td>
									<td>
										{{inv.usd_due_date}}
									</td>
									<td>
										@if (!inv.isActive) {
										@if (inv.usd_bill_flag) {
										<fa-icon [icon]="['fas','check']" class="text-success"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas','minus']" class="text-danger"></fa-icon>
										}
										}@else {
										<ng-toggle [(ngModel)]="inv.usd_bill_flag"
											[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
											[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
											[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
											[labels]="{'unchecked': 'Unbilled','checked': 'Billed'}" [width]="100"
											(change)="billedOrPaidToggleChanged($index)"
											[disabled]="navbar.userAccess?.Invoice!='Full'">
										</ng-toggle>
										}
									</td>
									<td>
										@if (!inv.isActive) {
										@if (inv.usd_paid_flag) {
										<fa-icon [icon]="['fas','check']" class="text-success"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas','minus']" class="text-danger"></fa-icon>
										}
										}@else {
										<ng-toggle [(ngModel)]="inv.usd_paid_flag"
											[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
											[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
											[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
											[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" [width]="100"
											(change)="billedOrPaidToggleChanged($index)"
											[disabled]="!inv.usd_bill_flag || navbar.userAccess?.Invoice!='Full'">
										</ng-toggle>
										}
									</td>
									<td>
										@if (inv.isActive) {
										<a class="btn btn-sm btn-primary me-1" matTooltip="Print"
											[routerLink]="['/app/invoice-pdf','usd',uId,inv.enc_id]" target="_blank">
											<fa-icon [icon]="['fas','print']"></fa-icon>
										</a>
										}
										@if(navbar.userAccess?.Invoice=='Full'){
										@if (inv.isActive) {
										<button class="btn btn-sm btn-info me-1" matTooltip="Edit"
											(click)="openConvertModal(true,$index)">
											<fa-icon [icon]="['fas','edit']"></fa-icon>
										</button>
										<button class="btn btn-sm btn-danger me-1" matTooltip="Delete"
											(click)="deleteConfirmUSD(inv.enc_id)">
											@if (showDeleteLoaderUSD == inv.enc_id) {
											<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
											}@else {
											<fa-icon [icon]="['fas','times']"></fa-icon>
											}
										</button>
										}
										}
										<!-- @if (inv.usd_invoice_path) { -->
										<button class="btn btn-sm btn-success me-1"
											matTooltip="Copy invoice link to clipboard"
											(click)="copyInvLinkToClipboard(inv,'USD')">
											@if (copyLoader === inv.enc_id) {
											<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
											}@else {
											<fa-icon [icon]="['fas','copy']"></fa-icon>
											}
										</button>
										<!-- } -->
									</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
					<div id="tab2" [ngClass]="getTabPaneClass(2)">
						@if (loadingBilling) {
						<div class="loader text-center">
							<img src="../../../assets/img/loading.gif" style="width: 100px;" />
							<p style="color: black;font-weight: bolder;">Loading...</p>
						</div>
						}@else {
						<div class="row g-1">
							<div class="col-md-12">
								<div class="card" @fadeInOut>
									<div class="card-header mb-0">
										<h5 class="card-title text-dark mb-0">
											Billing
										</h5>
									</div>
									<div class="card-body pt-1">
										<div class="row mb-1">
											<div class="col-2 offset-10">
												<select class="form-select form-select-sm" [(ngModel)]="billingFilter">
													@for (opt of billingFilterList; track $index) {
													<option value="{{opt}}">{{opt}}</option>
													}
												</select>
											</div>
										</div>
										<table class="table table-bordered">
											<thead>
												<tr>
													<th style="width: 15% !important;">Date</th>
													<th style="width: 10% !important;">Category</th>
													<th style="width: 14% !important;">Notes</th>
													<th style="width: 10% !important;">Amount</th>
													<th style="width: 10% !important;">Files</th>
													<th style="width: 10% !important;">QR Code</th>
													<th style="width: 10% !important;">Gpay</th>
													<th style="width: 6% !important;">Paid</th>
													<th style="width: 5% !important;">Approval</th>
													<th style="width: 5% !important;">Reimbursement</th>
													<th style="width: 5% !important;">Billed</th>
												</tr>
											</thead>
											<tbody>
												@for (bill of followUpBillsData; track $index) {
												@if (showBillRow(bill)) {
												<tr [ngClass]="{ 'orange': !bill.files || bill.files.length==0 }">
													<td>
														{{bill.date}}
													</td>
													<td>
														{{bill.category_name}}
													</td>
													<td>
														{{bill.notes}}
													</td>
													<td>
														{{bill.amount}}
													</td>
													<td>
														@if (bill.files) {
														@for (file of bill.files; track $index) {
														<div class="icon-container no-delete">
															<file-icon [file]="file"></file-icon>
														</div>
														}
														}
													</td>
													<td>
														@if(bill.qrcode_files){
														@for (file of bill.qrcode_files; track $index) {
														<div class="icon-container no-delete">
															<file-icon [file]="file"></file-icon>
														</div>
														}
														}
													</td>
													<td>
														@if (bill.gpay_files) {
														@for (file of bill.gpay_files; track $index) {
														<div class="icon-container no-delete">
															<file-icon [file]="file"></file-icon>
														</div>
														}
														}
													</td>
													<td>
														@if (bill.is_paid) {
														<fa-icon [icon]="['fas', 'check']"
															class="text-success"></fa-icon>
														}
													</td>
													<td>
														@if (bill.is_approved) {
														<fa-icon [icon]="['fas', 'check']"
															class="text-success"></fa-icon>
														}
													</td>
													<td>
														@if (bill.reimbursement) {
														<fa-icon [icon]="['fas', 'check']"
															class="text-success"></fa-icon>
														}
													</td>
													<td>
														@if (bill.used_in_invoice) {
														<fa-icon [icon]="['fas', 'check']"
															class="text-success"></fa-icon>
														}
													</td>
												</tr>
												}
												}
												<tr>
													<th colspan="3" class="text-end">Total</th>
													<td colspan="7">{{ caseDetails?.total_cost }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<div class="modal fade" id="convertModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Convert to USD</strong></h4>
				<button type="button" class="btn-close" (click)="closeConvertModal();"></button>
			</div>
			<form [formGroup]="moduleForm" (ngSubmit)="convertToUSD()" #modform="ngForm">
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('usd_invoice_number')}" placeholder=""
									formControlName="usd_invoice_number" class="form-control" />
								<label for="usd_invoice_number">Invoice Number*</label>
							</div>
							@if (showError('usd_invoice_number')) {
							<p class="text-danger">
								@if (f.usd_invoice_number.errors?.required) {
								<span>
									Required
								</span>
								}
							</p>
							}
						</div>
						<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div class="input-group">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('usd_invoice_date')}" placeholder=""
										class="form-control" formControlName="usd_invoice_date" ngbDatepicker
										id="usd_invoice_date" #usd_invoice_date="ngbDatepicker" [minDate]="minDate" />
									<label for="usd_invoice_date">Invoice Date*</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="usd_invoice_date.toggle()"
									type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							@if (showError('usd_invoice_date')) {
							<p class="text-danger">
								@if (f.usd_invoice_date.errors?.required) {
								<span>
									Required
								</span>
								}
							</p>
							}
						</div>
						<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div class="input-group">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('usd_due_date')}" placeholder=""
										class="form-control" formControlName="usd_due_date" ngbDatepicker
										id="usd_due_date" #usd_due_date="ngbDatepicker" [minDate]="minDate" />
									<label for="usd_due_date">Due Date*</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="usd_due_date.toggle()" type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							@if (showError('usd_due_date')) {
							<p class="text-danger">
								@if (f.usd_due_date.errors?.required) {
								<span>
									Required
								</span>
								}
							</p>
							}
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('usd_conversion_rate')}" placeholder=""
									formControlName="usd_conversion_rate" class="form-control" />
								<label for="usd_conversion_rate">
									Conversion Rate*
									<small style="font-size: x-small;">(INR per USD)</small>
								</label>
							</div>
							@if (showError('usd_conversion_rate')) {
							<p class="text-danger">
								@if (f.usd_conversion_rate.errors?.required) {
								<span>
									Required
								</span>
								}
								@if (f.usd_conversion_rate.errors?.pattern) {
								<span>
									Invalid
								</span>
								}
							</p>
							}
						</div>
						<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
							<br />
							<ng-toggle formControlName="usd_bill_flag"
								[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
								[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
								[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
								[labels]="{'unchecked': 'Unbilled','checked': 'Billed'}" [width]="90"
								(change)="usdBillFlagChanged()" class="me-2">
							</ng-toggle>
							<ng-toggle formControlName="usd_paid_flag"
								[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
								[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
								[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
								[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" [width]="90">
							</ng-toggle>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="!modform.dirty || convertLoader">
						@if (convertLoader) {
						<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
						}@else {
						<fa-icon [icon]="['fas','save']"></fa-icon>
						}
						Submit
					</button>
					<button type="button" class="btn btn-sm btn-warning" (click)="closeConvertModal();">Cancel</button>
				</div>
			</form>
		</div>
	</div>
</div>